$(function(){

  var $humb = $('#humb');
  var $mnav = $('#mainnav');
  var $win = $(window);
  var $b = $('body');

  var posY = 0;
  $humb.on('click', function(){
    if ($humb.hasClass('-active')) {
      // $('body,html').css({'overflow':'visible','height':'auto'});
      $win.scrollTop(posY);
      $mnav.fadeOut(400);
      $humb.removeClass('-active');
      $b.removeClass('noscrl');
    } else {
      posY = $win.scrollTop(); //docHもとる
      // console.log(posY);
      $b.addClass('noscrl');
      $humb.addClass('-active');
      $mnav.fadeIn(400, function(){
        // $('body,html').css({'overflow':'hidden','height':'100%'});
      });
      $mnav.scrollTop(0);
    }
  })

  enquire.register('screen and (max-width:1080px)', {
    unmatch : function() {
      //PC
      $mnav.removeAttr('style');
      $humb.removeClass('-active');
      $b.removeClass('noscrl');
    },
  });

  function checkMenuH() {
    var $winH = $win.height();
    // var $menuH = $mnav.find('.mainnav-content').innerHeight();
    var $menuH = 596; //shareボタン除く
    if ($winH < $menuH) {
      $mnav.addClass('-abs');
    } else {
      $mnav.removeClass('-abs');
    }
  }
  checkMenuH();

  // menu 高さ監視
  var timer = 0;
  $win.on('resize',function() {
    if (timer > 0) {
      clearTimeout(timer);
    }
    timer = setTimeout(function () {
      checkMenuH();
    }, 200);
  });

});
